/* eslint-disable no-debugger */
/* eslint-disable no-useless-return */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
import axios from "axios";
// import {  } from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MdReplay } from "react-icons/md";
import styles from "./UnBookedHrsReportForm.module.css";
import {
  CustomDatePicker,
  CustomFormGroup,
} from "../FormComponents";
import {
  DATE_FORMAT,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
} from "../../constants";
import ReportTable from '../ReportTableComponent/ReportTable';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import {
  fetchChassis,
  getInvoice,
} from "../../redux/actions/productsActions";
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";

const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: "",
  },
  errors: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

const UnBookedHrsReportForm = (
  redirectToProcessPage,
  product,
  counter,
) => {
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const { userRole } = auth;

  let UserRoles = userRole;
  let MangerFlag = UserRoles.includes("M");
  let SFlag = UserRoles.includes("S");
  let DSFlag = UserRoles.includes("DS");
  let SAFlag = UserRoles.includes("SA");

  let requiredUsers= ["DS","SA","M","S"];
  const[userList,setUserList]=useState(UserRoles.filter(role => requiredUsers.includes(role)))
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const [viewDisplay, setViewDisplay] = useState(false);
  const dispatchNew = useDispatch();
  const history = useHistory();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);


 
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
 
  const [allTableData,setAllTableData]=useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [tableFlag,setTableFlag]=useState(false);
  const [allData,setAllData]=useState([]);
  const HEIGHT = '';
  const FILENAME = 'Unbooked_Hrs_Report';

  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    checkType4:''
  });
  const [loadings,setLoadings]=useState(false)
  
   const handleDate = (date, name) => {
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;

    }
    let newDate = date.format(DATE_FORMAT.ISO)
    setState((prevData) => ({ ...prevData, [name]: date }));

  }
  useEffect(() => {
    setViewDisplay(true);
  }, []);

  useEffect(()=>{
    getCheckValidDate()
  },[])

  const getCheckValidDate = () => {
    setLoadings(true)
    let data={}
    axios
      .post(`${baseUrl}timeBooking/checkValidDate`,data,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        dispatchNew(setLogin({ ...auth, recentStatus: response.status }));
        if(response.data.msg==="Success"){
          setLoadings(false)
          setState((pre)=>({
            ...pre,
            fromDate:moment(response?.data?.data[0][0],"YYYY-MM-DD").format("MM-DD-YYYY"),
            toDate:moment(response?.data?.data[0][1],"YYYY-MM-DD").format("MM-DD-YYYY")
          }))
        }
        if(response.data.msg==="Fail"){
          setLoadings(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later.",
        })
        }  
      })
      .catch((error) => {
        setLoadings(false);
        dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
        if (error.response.status === 403) {
          // Handle 403 Forbidden
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        } else if (error.response.status === 423) {
          // Handle 403 Forbidden
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        } else if (error.response.status === 503){
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        }else {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later.",
        })
          // Handle other HTTP errors
          console.error("Error response data:", error.response.data);
        }
      });
  };

  useEffect(()=>{
    if(userList?.length == 1){
      setState((prev) => ({
        ...prev,
        checkType4:userList[0]
      }));
    }
  },[userList])

  const asyncPostCall = async (data) => { 
    setLoadings(true)
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);
    if (myState.checkType4==null || myState.checkType4=="") {
      setLoadings(false)
      setAllTableData([]) 
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Select Role"
      })
      return
    } 
    if (myState.fromDate == "" || myState.toDate == ""  || myState.fromDate==null ||myState.toDate==null) {
      setLoadings(false)
      setAllTableData([]) 
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter a date"
      })
      return
    } 
    const isSameOrAfter = moment(fromDate).isAfter(toDate); 
    if (isSameOrAfter) {
       setLoadings(false)
       setAllTableData([])
       setTableData([])
       showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "End Date Should Be Greater Than  Or Equal To Start Date ",
      });
      if(userList?.length != 1){
      setState((prev)=>({
        ...prev,
        checkType4:""
      }))
      }}
    else {
      let finalfromdate=moment(fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
      let finaltodate=moment(toDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
   
      let apiFormatedData = {
          "pers_no":sanitizeNumeric(auth.personNumber),
          "user_role":data,
          "co_code":sanitizeCoCodeNumeric(auth.companyCode),
          "dtfrom":finalfromdate,
          "dtto":finaltodate
       };
       try{
        var apiFormatedDataJson = JSON.stringify(apiFormatedData);
        let headerss = new Headers();
        headerss.append("Content-Type", "application/json");
         fetch(`${baseUrl}reports/UnBookedHrsReport`, {
          method: "POST",
          headers: headerss,
          credentials:'include',
          body: apiFormatedDataJson,
        })
        .then((response) => {
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoadings(false);
          }
          return response.json();
          })
          .then((responseJson) => {
          if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setLoadings(false);
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setTableData(finalList)  
          setAllTableData(finalList)
        }
         else if (responseJson.msg=="Success" && responseJson?.data?.length ==0) {
            setLoadings(false)
            setAllTableData([])
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "No Records Found",
            });}
            else if(responseJson && responseJson.msg=="Fail")  {
              setLoadings(false);
              setAllTableData([])
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: responseJson.data,
            })
            }  
          })
       }
       catch(error){
        setLoadings(false);
        setAllTableData([])
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later. Please try again later",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
        }
       }
            
    }
  }

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29

      return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  };

  const showError = (msg) => {
    showPopup({
      type: MESSAGE_TYPE.FAILURE,
      contextText: MESSAGE_TYPE.FAILURE,
      info: msg,
    });
  };

 
 

  const handleSubmit = () => {
    setLoadings(true)
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);
  
    
    if (myState.fromDate == "" || myState.toDate == ""  || myState.fromDate==null ||myState.toDate==null) {
      setLoadings(false)
      setAllTableData([])
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter a date"
      });
      return
    } 
    const isSameOrAfter = moment(fromDate).isAfter(toDate);
    if (isSameOrAfter) {
      setLoadings(false)
      setAllTableData([])
      setTableData([])
      showPopup({
       type: MESSAGE_TYPE.INFORMATION,
       contextText: MESSAGE_TYPE.INFORMATION,
       info: "End Date Should Be Greater Than  Or Equal To Start Date ",
     });
     setState((prev)=>({
       ...prev,
       checkType4:""
     }))
     }
    else {
    let finalfromdate=moment(fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
    let finaltodate=moment(toDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
    let apiFormatedData = {
      "pers_no":sanitizeNumeric(auth.personNumber),
      "user_role":userRole[0],
      "co_code":sanitizeCoCodeNumeric(auth.companyCode),
      "dtfrom":finalfromdate,
      "dtto":finaltodate
   };
   
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}reports/UnBookedHrsReport`, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      })
        .then((response) => {
        
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoadings(false);
          }
          return response.json();
          })
        .then((responseJson) => {
        
          if (responseJson.msg=="Success"  && responseJson?.data?.length ==0) {
            setLoadings(false);
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "No Records Found",
            });}
           else if (responseJson.msg=="Success" && responseJson.data.length != 0) 
            {
             
              setLoadings(false);
              const finalList = [];
              responseJson.data.map((row, index) => {
                finalList.push({
                  id: index,
                  ...row,
                });
              });
              setAllData(finalList)
                setAllTableData(finalList)
              setTableData(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
            
              setTableFlag(true)
             
            }
            else if(responseJson && responseJson.msg=="Fail")  {
              setLoadings(false);
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: responseJson.data,
            })
            } 
        
        })
        .catch((error) => {
          setLoadings(false);
          if (error instanceof TypeError) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "There might be Network issue, please try after some time",
          })
          } else {
            // Handle HTTP errors
            console.error('HTTP Error:', error);
            if (error.response) {
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Oops! Something went wrong. Please try again later",
            })
            }
          }
        });
    }
  };

  const exportExcel = async (excelRowData) => {
   
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    var fileName = "Report" + moment().format("DD/MM/YYYY LT");

    const ws = XLSX.utils.json_to_sheet(excelRowData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `${fileName}${fileExt}`);
  };

 
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const handleClose = () => setIsPopupOpen(false);
  
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const baseDefaultColumns = [
    {
      width: 100,
      title: "Person No",
      field: "pers_no",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "Name",
      field: "empl_name",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 240,
      title: "Work Area",
      field: "workarea",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 110,
      title: "BC No",
      field: "bc",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 280,
      title: "BC Description",
      field: "bc_desc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Muster Date",
      field: "muster_date",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 120,
      title: "Hrs Available for Booking",
      field: "hrs_available_for_booking",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "Month",
      field: "mon",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "Hours",
      field: "hrs",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 110,
      title: "Ex Indc",
      field: "excep_indc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "Grade Group",
      field: "grade_grp",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Company",
      field: "company",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Location",
      field: "location",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: "Manager/Supervisor Ticket No.",
      field: "MANAGER_SUPERVISOR_TKTNO",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: "Manager/Supervisor Name",
      field: "MANAGER_SUPERVISOR_NAME",
      enableSearch: true,
      enableFilter: true,
    },
  ];
  const handleCheck4=(e)=>{
    setState((prev)=>({
      ...prev,
      checkType4:e.target.value
    }))
  }
  const handleOpen=()=>{
    window.location.reload()
  }
  const reportType = () => (
    <div className={styles.formGroup}> 
       { userList?.length > 1  &&
       <Grid
       container
       spacing={0}
       style={{ marginTop: "10px" }}
       className={styles.myGrid}
       columns={12}
     >
       {MangerFlag ? (
       <>
       <Grid item md={3} lg={3} sm={12}>
      
          <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4} 
             >
               <FormControlLabel 
                 value="M"
                 name="status4"
                 label="Manager"
                control={<Radio size="small" />}  />
             </RadioGroup>
       </Grid>
       </>
       ): (
         "")}
       {SFlag ? (
         <>
       <Grid item md={3} lg={3} sm={12}>
          <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4} 
             >
               <FormControlLabel 
                 value="S"
                 name="status4"
                 label="Supervisor"
                control={<Radio size="small" />}  />
             </RadioGroup>
       </Grid>
       </>
       ):("")}

      {DSFlag ? (
       <>
       <Grid item md={3} lg={3} sm={12}>
         <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4} 
             >
               <FormControlLabel 
                 value="DS"
                 name="status4"
                
                 label="Departmental SPOC"
                control={<Radio size="small" />}  />
             </RadioGroup>
       </Grid>
       </>
      ):("")}

      {SAFlag ? (
       <>
       <Grid item md={3} lg={3} sm={12}>
          <RadioGroup
               row
               aria-labelledby="demo-row-radio-buttons-group-label"
               name="row-radio-buttons-group"
               required={true}
               value={myState.checkType4}
               style={{
                 marginLeft: "27px",
                 marginRight: "20px"
               }}
               onChange={handleCheck4}              
             >
               <FormControlLabel 
                 value="SA"
                 name="status4"
                
                 label="Super Admin"
                control={<Radio size="small" />}  />
             </RadioGroup>
       </Grid>
       </>
      ) : ("")}  
     </Grid>
      
      
      }
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => { handleDate(e, 'fromDate') }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        

        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {
                  handleDate(e, 'toDate')
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}

              />
            </div>
          </div>
        

        </Grid>
       
         <Grid item md={2} lg={2}>
         <div className={clsx(styles.rowDiv)}>
             <div className={styles.formDiv}>
               <Button
                 className={clsx(
                   styles.actionButton,
                   styles.primaryActionButton
                 )}
                 variant="primary"
                 onClick={() => asyncPostCall(myState.checkType4)}
                 data-testid="confirm-action"
               >
                 Submit
               </Button>
               <Button
            className={clsx(styles.actionButton, styles.resetButton)}
            variant="tertiary"
            onClick={handleOpen}
            style={{marginLeft: "15px"}}
            >
            Cancel
          </Button>
               </div>
               </div>
         </Grid>
        
      </Grid>
      <div>
        {allTableData?.length>0  && userRole.length > 1 && (
        <Grid
            container
            spacing={1}
            style={{ marginTop: "10px" }}
            columns={12}
          >
        <Grid item md={12} lg={12} xs={12} sm={10}>
          <div
            className={styles.col2}
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            
              <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>
          </div>
        </Grid>
        </Grid>)}
      </div>
    </div>
      );

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    // resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  const renderReport1 = () => (
    <div
      className={styles.formGroup}>
      <div
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >
       
          
            <>
            <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>
        </>
         
      </div>
  
    </div>)

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >
          <CustomFormGroup  header="Unbooked Hrs Report" body={reportType()} />
        { userRole.length == 1 && allTableData.length>0 &&
         renderReport1()
        } 
          {loadings ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>
       
        ) : ""}  
        
      </div>

      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

UnBookedHrsReportForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
UnBookedHrsReportForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(UnBookedHrsReportForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);